// @flow

export const PLUGIN_NAME = 'trix-web-plugin-pay-paymentdue';
